import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

export default function Top() {
  return (
    <section
      id="naadi-section"
      style={{
        fontFamily: "'Poppins', sans-serif",
        background: "linear-gradient(135deg, #f7dc64ff 0%, #ebf792ff 100%)",
        color: "#222",
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "50px 15px",
        marginTop: "5rem",      // ⬆️ increased spacing from top
        marginBottom: "3rem",   // ⬇️ added balanced bottom spacing
        boxSizing: "border-box",
      }}
    >
      <div
        id="naadi-container"
        style={{
          width: "100%",
          maxWidth: "880px",
          background: "linear-gradient(135deg, #f7dc64ff 0%, #ebf792ff 100%)",
          borderRadius: "25px",
          border: "1px solid #000",
          padding: "45px 30px",
          textAlign: "center",
          backdropFilter: "blur(12px)",
        }}
      >
        {/* Header */}
        <div
          id="naadi-header"
          style={{
            backgroundColor: "#26734d",
            color: "#fff",
            padding: "10px 24px",
            borderRadius: "40px",
            display: "inline-block",
            fontWeight: 600,
            fontSize: "15px",
            marginBottom: "20px",
            letterSpacing: "0.5px",
          }}
        >
          Get Your Naadi Prediction
        </div>

        {/* Title */}
        <h1
          id="naadi-title"
          style={{
            color: "#800000",
            fontWeight: 800,
            fontSize: "24px",
            lineHeight: "1.5",
            marginBottom: "14px",
          }}
        >
          SRI AGASTHIYA MAHA SHIVA SUKSHAMA NAADI JYOTHISHAM
        </h1>

        {/* Subtitle */}
        <p
          id="naadi-subtext"
          style={{
            fontSize: "15px",
            fontWeight: 500,
            color: "#333",
            marginBottom: "28px",
          }}
        >
          India’s Leading Online Nadi Astrology Center
        </p>

        {/* Points list */}
        <ul
          id="naadi-list"
          style={{
            textAlign: "left",
            listStyle: "none",
            padding: 0,
            maxWidth: "600px",
            margin: "0 auto 30px",
          }}
        >
          {[
            "Astrology Consultations Available Online",
            "Instant Nadi Readings from Anywhere",
            "Naadi Prediction through WhatsApp",
          ].map((text, index) => (
            <li
              key={index}
              style={{
                marginBottom: "12px",
                fontSize: "15.5px",
                color: "#222",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span
                style={{
                  width: "9px",
                  height: "9px",
                  backgroundColor: "#a30000",
                  borderRadius: "50%",
                  flexShrink: 0,
                }}
              ></span>
              {text}
            </li>
          ))}
        </ul>

        {/* Contact Buttons */}
        <div
          id="naadi-buttons"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          {/* WhatsApp Button */}
          <a
            id="btn-whatsapp"
            href="https://wa.me/917402167580"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              backgroundColor: "#25D366",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: "40px",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "15px",
              width: "200px",
              boxShadow: "0 4px 12px rgba(37, 211, 102, 0.4)",
              transition: "transform 0.2s ease, box-shadow 0.3s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow =
                "0 6px 16px rgba(37, 211, 102, 0.5)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(37, 211, 102, 0.4)";
            }}
          >
            <FaWhatsapp size={18} />
            WhatsApp
          </a>

          {/* Phone Button */}
          <a
            id="btn-call"
            href="tel:+917402167580"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              backgroundColor: "#007bff",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: "40px",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "15px",
              width: "200px",
              boxShadow: "0 4px 12px rgba(0, 123, 255, 0.4)",
              transition: "transform 0.2s ease, box-shadow 0.3s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow =
                "0 6px 16px rgba(0, 123, 255, 0.5)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(0, 123, 255, 0.4)";
            }}
          >
            <FaPhoneAlt size={16} />
            Call Now
          </a>
        </div>
      </div>

      {/* Responsive CSS */}
      <style>
        {`
          #naadi-section h1, 
          #naadi-section p, 
          #naadi-section ul li {
            transition: all 0.3s ease;
          }

          @media (max-width: 768px) {
            #naadi-container {
              padding: 35px 20px !important;
            }
            #naadi-title {
              font-size: 20px !important;
            }
            #naadi-subtext {
              font-size: 14px !important;
              margin-bottom: 20px !important;
            }
            #naadi-list li {
              font-size: 14px !important;
              margin-bottom: 10px !important;
            }
            #naadi-buttons a {
              width: 160px !important;
              font-size: 14px !important;
              padding: 9px 15px !important;
            }
          }

          @media (max-width: 480px) {
            #naadi-container {
              padding: 30px 15px !important;
            }
            #naadi-title {
              font-size: 18px !important;
            }
            #naadi-buttons {
              flex-direction: column !important;
              gap: 8px !important;
            }
            #naadi-buttons a {
              width: 100% !important;
              max-width: 260px !important;
            }
          }
        `}
      </style>
    </section>
  );
}
